module.exports = __webpack_public_path__ + "media/images/covid/banner/sidebar/zh-hans-79f3c3916d0f5bd82c7b8d8e6f76753d.jpg";